/** Read-only lines from GET passport `stats` for LIST / table blocks (shape varies by backend). */

export type PassportStatsLine = {
  label: string
  value: string
}

export function statsSummaryLines(stats: unknown): PassportStatsLine[] {
  if (!stats || typeof stats !== 'object') return []
  const value = (stats as Record<string, unknown>).value
  const unit = (stats as Record<string, unknown>).unit
  if (!value || typeof value !== 'object') return []
  const unitMap =
    unit && typeof unit === 'object' ? (unit as Record<string, string>) : ({} as Record<string, string>)
  const out: PassportStatsLine[] = []
  for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
    const u = unitMap[key]
    const v = val === null || val === undefined ? '—' : String(val)
    out.push({ label: key, value: u ? `${v} ${u}` : v })
  }
  return out
}

export function statsLinkedObjectCount(stats: unknown): number | null {
  if (!stats || typeof stats !== 'object') return null
  const ids = (stats as Record<string, unknown>).object_ids
  if (!Array.isArray(ids)) return null
  return ids.length
}
